import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import S from '../../styled';

// Components
import Page from '../../components/Page';

// Requests
import { discordAuthenticate } from '../../data/requests/user';
import { addDiscord, connectDiscord } from '../../data/requests/profile';

const clientDomain = process.env.REACT_APP_CLIENT_DOMAIN;

const DiscordCallback = () => {
  const location = useLocation();
  const invalidResponseRedirectUrl = (accountToken) => `${clientDomain}/${accountToken}/invalid`;

  const invalidResponseRedirect = (accountToken, error) => {
    window.location.href = invalidResponseRedirectUrl(accountToken);
    console.error('getDiscordAuthToken', error);
  }

  const loginUser = async (code, accountToken) => {
    try {
      const userData = await discordAuthenticate(code, accountToken);
      if (userData) {
        window.location.href = `${clientDomain}/${accountToken}`;
      }
    } catch (error) {
      invalidResponseRedirect(accountToken, error);
    }
  }

  const addUser = async (code, accountToken) => {
    try {
      const userData = await addDiscord(code, accountToken);
      if (userData) {
        window.location.href = `${clientDomain}/${accountToken}/networks`;
      } else {
        window.location.href = invalidResponseRedirectUrl(accountToken);
      }
    } catch (error) {
      invalidResponseRedirect(accountToken, error);
    }
  };

  const connectUser = async (code, accountToken, state) => {
    try {
      const { profile_id: profileId, username } = state;
      const userData = await connectDiscord(code, accountToken, profileId, username);
      if (userData) {
        window.location.href = `${clientDomain}/${accountToken}/networks`;
      } else {
        window.location.href = invalidResponseRedirectUrl(accountToken);
      }
    } catch (error) {
      invalidResponseRedirectUrl(accountToken, error);
    }
  };

  const getDiscordAuthToken = async () => {
    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get('code');
    const state = queryParams.get('state');
    const decodedState = JSON.parse(decodeURIComponent(state));
    const { account_token: accountToken, action } = decodedState;
    if (code && accountToken) {
      if (action === 'login') {
        await loginUser(code, accountToken);
      } else if (action === 'add') {
        await addUser(code, accountToken);
      } else if (action === 'connect') {
        await connectUser(code, accountToken, decodedState);
      }
    } else {
      window.location.href = invalidResponseRedirectUrl(accountToken);
      console.error('No code or account token when authenticating with discord');
    }
  };

  useEffect(() => {
    getDiscordAuthToken();
  }, [])

  return (
    <Page>
      <S.Flex row alignCenter justifyCenter>
        <S.Spinner />
      </S.Flex>
    </Page>
  );
}

export default DiscordCallback;
